module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1504-d5ef82f293b7dcc2180ac93c51391881.png";